import { Card, CardActionArea, CardContent, Stack, Typography } from '@mui/material'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { useFormatter } from '@omnea-app/fe-i18n/useFormatter'
import { UserAvatar } from '@omnea-app/fe-users-and-groups/avatar/UserAvatar'
import { RequestStepStatusChip } from './RequestStepStatusChip'
import type { SupplierStep } from '../useGetSupplierSteps'

export const matchesSupplierStepMobileCardContent = (step: SupplierStep, searchTermLower: string): boolean => {
  return step.blockName.toLowerCase().includes(searchTermLower) || step.requestName.toLowerCase().includes(searchTermLower)
}

export const SupplierStepMobileCard = ({ step }: { step: SupplierStep }) => {
  const { t } = useTranslation('supplier-dashboard', { keyPrefix: 'tasks-table' })
  const { formatDate } = useFormatter()

  const isCompleted = step.status === 'COMPLETE'

  return (
    <Card>
      <CardActionArea LinkComponent={Link} href={`/supplier-onboarding/${step.requestId}/${step.id}/overview`}>
        <CardContent>
          <Stack gap={3}>
            <Stack sx={{ justifyContent: 'space-between', flexDirection: 'row' }} alignItems="center">
              <RequestStepStatusChip
                status={step.status}
                amendments={step.amendmentRequests}
                tasks={step.tasks}
                stepType={step.stepType}
              />
              {!isCompleted && step.dueDate && (
                <Typography variant="Body14pxRegular" color="neutralLight.900">
                  {t('mobile.task-card.due')}: {formatDate(new Date(step.dueDate), { format: 'short' })}
                </Typography>
              )}
            </Stack>
            <Stack gap={1}>
              <Typography variant="Body14pxMedium">{step.blockName || '-'}</Typography>
              <Typography variant="Body14pxRegular" color="neutralLight.900">
                {step.requestName || '-'}
              </Typography>
            </Stack>
            <Stack gap={1}>
              <Typography variant="Body12pxRegular" color="neutralLight.700">
                {t('columns.type')}: {t(`request-type.${step.type}`)}
              </Typography>
              <Stack direction="row" gap={1} alignItems="center">
                <Typography variant="Body12pxRegular" color="neutralLight.700">
                  {t('columns.requestedBy')}:
                </Typography>
                <UserAvatar user={step.requestor} />
                <Typography variant="Body12pxRegular" color="neutralLight.900">
                  {step.requestor.name}
                </Typography>
              </Stack>
              <Typography variant="Body12pxRegular" color="neutralLight.700">
                {t('columns.requestedOn')}: {formatDate(new Date(step.requestedOn), { format: 'short' })}
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
